import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PublicLandingGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // For landing page routes, only check synchronously to avoid triggering OIDC flow
    const path = route.routeConfig?.path || '';
    const currentUrl = this.router.url || '';
    const isLandingRoute = path === '' || path === 'landing' || currentUrl === '/' || currentUrl === '/landing';
    
    if (isLandingRoute) {
      // Only check synchronously - don't call isAuthenticated() which might trigger OIDC flow
      // Since auth isn't initialized on landing page, isLoggedIn() will return false
      // which is correct - we want to show the landing page
      try {
        const isLoggedIn = this.authService.isLoggedIn();
        if (isLoggedIn) {
          this.router.navigate(['profile/overview'], { replaceUrl: true });
          return false;
        }
      } catch (error) {
        // console.debug(`PublicLandingGuard: If isLoggedIn() throws (e.g., auth not initialized), that's fine - allow landing page`, error);
      }
      // console.debug('PublicLandingGuard: Allow landing page to show without triggering auth flow');
      return true;
    }

    // For other routes (wildcard), check if logged in
    try {
      if (this.authService.isLoggedIn()) {
        this.router.navigate(['profile/overview'], { replaceUrl: true });
        return false;
      }
    } catch (error) {
      console.debug('PublicLandingGuard: If auth not initialized, allow access (will show landing page for unknown routes)', error);
    }
    
    console.debug('PublicLandingGuard: Allowing access to unknown route');
    return true;
  }
}

